import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    const r = await register(form.name, form.email, form.password);
    setBusy(false);
    if (r.ok) { toast.success("Account created!"); nav("/dashboard"); }
    else { toast.error(r.error); }
  };

  return (
    <div data-testid="register-page" className="pt-32 pb-24 container mx-auto px-4 max-w-md">
      <h1 className="font-display font-black text-4xl mb-6">Create your account.</h1>
      <form onSubmit={submit} className="space-y-4 bg-white border border-zinc-200 rounded-2xl p-7">
        <input required placeholder="Full name" value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          data-testid="register-name" className="w-full px-4 py-3 border border-zinc-300 rounded-lg" />
        <input required type="email" placeholder="Email" value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          data-testid="register-email" className="w-full px-4 py-3 border border-zinc-300 rounded-lg" />
        <input required type="password" placeholder="Password (min 6 chars)" value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          data-testid="register-password" className="w-full px-4 py-3 border border-zinc-300 rounded-lg" />
        <button type="submit" disabled={busy} data-testid="register-submit"
          className="w-full px-6 py-3 rounded-full bg-gradient-brand text-white font-bold disabled:opacity-50">
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="text-center text-sm text-zinc-500 mt-5">
        Already have an account? <Link to="/login" className="font-semibold text-[#FF007F]">Sign in</Link>
      </p>
    </div>
  );
}
